// extracted by mini-css-extract-plugin
export var close = "tooltip-module--close--8fdbf";
export var container = "tooltip-module--container--4b3f0";
export var readMore = "tooltip-module--readMore--ad05f";
export var small = "tooltip-module--small--8163f";
export var smallContainer = "tooltip-module--smallContainer--476e4";
export var text = "tooltip-module--text--bf088";
export var tooltip = "tooltip-module--tooltip--b51c5";
export var tooltipContainer = "tooltip-module--tooltipContainer--b1fb4";
export var tooltipSmall = "tooltip-module--tooltipSmall--be84b";